import { Component, AfterViewInit } from '@angular/core';
import * as Chart from 'chart.js';
@Component({
  selector: 'app-line-trend',
  templateUrl: './line-trend.component.html',
  styleUrls: ['./line-trend.component.css']
})
export class LineTrendComponent implements AfterViewInit {

  canvas: any;
  ctx: any;

  ngAfterViewInit() {
    Chart.defaults.global.defaultFontColor = '#000';
    this.canvas = document.getElementById('myTrend');
    this.ctx = this.canvas.getContext('2d');
    const myTrend = new Chart(this.ctx, {
      type: 'bar',
      data: {
        labels: ['January', 'Febraury', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        datasets: [
          {

            label: 'Compliance',
            data: [20, 35, 15],
            backgroundColor: 'rgba(255, 99, 132, 1)'
          },
          {
            label: 'Functional',
            data: [28, 18, 16],
            backgroundColor: 'rgba(54, 162, 235, 1)'
          },
          {
            label: 'Performance',
            data: [12, 13, 8],
            backgroundColor: 'rgba(255, 206, 86, 1)'
          },
          {
            label: 'Security',
            data: [15, 25, 10],
            backgroundColor: 'rgba(12, 96, 120, 1)'
          },
          {
            label: 'Usability',
            data: [8, 16, 7],
            backgroundColor: 'rgba(56, 240,156, 1)'
          }
        ]
      },
      options: {
        responsive: true,
        display: true,
        maintainAspectRatio: false
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/line-trend/line-trend.component.ts